import { isAuthRoute } from '@/lib/auth/isAuthRoute'

export function sanitizeNextPath(nextParam: string | null | undefined): string {
  if (!nextParam || !nextParam.startsWith('/')) return '/'
  if (nextParam.startsWith('//')) return '/'
  if (nextParam.includes('\\') || nextParam.includes('..')) return '/'
  if (nextParam.startsWith('/app2')) return '/'
  if (isAuthRoute(nextParam)) return '/'
  return nextParam
}
